export class UserProfileResponse {
 email: string;
 fullName: string;
 username: string;
 password: string;
 success: string;
 ldapSourceId: number;
 lineManagerFullName: string;
 city: string;
}
